



















































































import { ref, defineComponent, computed, watch } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import Pin from '@getaccept/lib-shared/src/components/Pin.vue';
import { ButtonType, MessageType } from '@getaccept/lib-ui';
import { storeToRefs } from 'pinia';
import { useMyDocumentsCreateEmail } from '../../my-documents/composables/my-documents-create-email.composable';
import { useMyDocumentsValidateEmail } from '../../my-documents/composables/my-documents-validate-email.composable';
import { useUserStore } from '../../user/store/user.store';
import { useMyDocumentsAuth } from '../../my-documents/composables/my-documents-auth.composable';

export default defineComponent({
  components: { Pin },
  setup() {
    const pin = ref('');

    watch(pin, (newVal, oldVal) => {
      if (oldVal.length < 6 && newVal.length === 6) {
        validateEmail(+pin.value);
      }
    });

    const { user } = storeToRefs(useUserStore());
    const email = computed(() => user.value?.email || '');

    const {
      mutateAsync: createEmail,
      isLoading: creatingEmail,
      isSuccess: creatededEmail,
      isError: createEmailError,
    } = useMyDocumentsCreateEmail();

    const {
      mutateAsync: validateEmail,
      isLoading: validating,
      isSuccess: validated,
      isError: validateError,
      isInvalidCode,
    } = useMyDocumentsValidateEmail();

    useMyDocumentsAuth(
      computed(() => user.value?.id),
      computed(() => validated.value)
    );

    const showErrorMessage = computed(
      () => createEmailError.value || (validateError.value && !isInvalidCode.value)
    );

    return {
      email,
      pin,
      pinLength: 6,
      creatededEmail,
      t,
      ButtonType,
      createEmail,
      creatingEmail,
      validateEmail,
      validating,
      validated,
      MessageType,
      showErrorMessage,
      isInvalidCode,
    };
  },
});
